// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { LocationType } from 'domains/models/event_type/locationType';
import EventTypeSubmitField from 'presentations/views/components/molecules/EventTypeSubmitField';
import { spacing, mediaMax, zIndex } from 'presentations/views/styles';
import { ErrorList } from 'domains/models';
import { Trail } from 'presentations/views/components/atoms/Transition';
import Workflow from 'domains/models/workflow';
import { white } from 'presentations/views/styles/color';
import { EventTypeServiceListItem } from 'presentations/api/schema/event_type_service';
import EventTypeContactFormBlock from '../EventTypeContactFormBlock';

export type Props = {
  onChange?: any;
  onChangeTextRemindNumber: (value: string, country: any) => void;
  onInputChangeTag?: any;
  onDeleteTag?: any;
  onSubmitTag?: any;
  onSubmit?: any;
  onBlur?: any;
  isLoading?: boolean;
  email: string | null;
  name: string | null;
  company: string | null;
  ccEmails: string[];
  message: string | null;
  phoneNumber: string | null;
  textRemindCountry: any | null;
  textRemindNumber: string | null;
  locationId: LocationType | null;
  isDisabled: boolean;
  errors: ErrorList;
  customQuestions: Workflow[];
  customQuestionAnswers: any[];
  customOtherAnswers: string[];
  onClickOtherAnswer?: Function;
  isCompanyHidden?: boolean;
  isCompanyRequired?: boolean;
  isCcEmailsHidden?: boolean;
  isCcEmailsRequired?: boolean;
  isMessageHidden?: boolean;
  isMessageRequired?: boolean;
  isPhoneNumberRequired?: boolean;
  isTextRemindNumberRequired?: boolean;
  isTextRemind: boolean;
  color: string;
  isLightColor: boolean;
  selectedServices: EventTypeServiceListItem[];
  isPaidServiceSelected: boolean;
  isProvidedContact: boolean;
  isRequest: boolean;
  isSelectedServicesHidePriceOnly: boolean;
};

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const submitLabel = (() => {
    if (props.selectedServices.length > 0) {
      if (props.isSelectedServicesHidePriceOnly) {
        return t('submit');
      } else {
        return props.isPaidServiceSelected
          ? t('select payment method')
          : t('preview');
      }
    } else {
      return t('submit');
    }
  })();

  return (
    <Form>
      <Scroller>
        <Trail isOpen={true}>
          <EventTypeContactFormBlock {...props} />
        </Trail>
      </Scroller>
      <Submit>
        <EventTypeSubmitField
          isLoading={props.isLoading}
          submitLabel={submitLabel}
          onSubmit={props.onSubmit}
          isDisabled={props.isDisabled}
          color={props.color}
          isLightColor={props.isLightColor}
        />
      </Submit>
    </Form>
  );
}

const Submit = styled.div`
  position: sticky;
  z-index: ${zIndex(300)};
  background: ${white};
  bottom: 0;
  width: 100%;
  height: 82px;
  padding-top: ${spacing(16)};
  padding-bottom: ${spacing(16)};
  ${mediaMax.smartphone} {
    position: inherit;
  }
`;

const Scroller = styled.div``;

const Form = styled.div`
  display: block;
  width: 100%;
  position: relative;
  padding: ${spacing(8)} ${spacing(40)} 0;
  ${mediaMax.smartphone} {
    padding: ${spacing(8)} ${spacing(16)} 0;
  }
`;
